import {
    MAX_CUSTOM_AMOUNT_BUTTONS_COUNT,
    MIN_CUSTOM_AMOUNT_BUTTONS_COUNT,
} from '@bg-shared/constants/constants';

export const parseCustomBettingAmounts = (customAmountsJson: string): number[] | undefined => {
    try {
        const customAmounts = JSON.parse(customAmountsJson);

        if (!Array.isArray(customAmounts)) {
            return undefined;
        }

        if (!customAmounts.length) {
            return [];
        }

        const parsedAmounts = customAmounts
            .map(parseFloat)
            .filter((item, index) => customAmounts.indexOf(item) === index && item > 0)
            .splice(0, MAX_CUSTOM_AMOUNT_BUTTONS_COUNT)
            .sort((a, b) => a - b);

        if (parsedAmounts.length < MIN_CUSTOM_AMOUNT_BUTTONS_COUNT) {
            return undefined;
        }

        return parsedAmounts;
    } catch {
        return undefined;
    }
};
